module.exports = __webpack_public_path__ + "static/nav.logo-6ffc7a939bfb5615a4e577f408ba5843.png";